import {
    useEffect,
    type FC
} from "react";
import type IFieldLegendProps from "./type";
import {
    FIELD_LEGEND_VARIANT,
    getFieldLegendColors
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useFieldOutsideWarning,
    useFieldSetContext
} from "../../context";
import Text from "../../../text";

const FieldLegend: FC<IFieldLegendProps> = ({
    customTheme: customThemeProp,
    children,
    ...props
}) => {
    const setContext = useFieldSetContext();

    useFieldOutsideWarning({
        isInside: !!setContext,
        parent: "Field.Set",
        part: "Legend"
    });

    const customTheme = customThemeProp ?? setContext?.customTheme;

    const {
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const currentColors = getFieldLegendColors({
        isDisabled: false,
        colors
    });

    const registerPart = setContext?.registerPart;

    useEffect(() => {
        if(!registerPart) {
            return;
        }

        return registerPart("legend");
    }, [
        registerPart
    ]);

    return <Text
        {...props}
        customColor={currentColors.color}
        variant={FIELD_LEGEND_VARIANT}
        customTheme={customTheme}
        id={setContext?.legendID}
    >
        {children}
    </Text>;
};
export default FieldLegend;
